import {useCallback, useEffect} from "react";

export default function useDragEvents(element, callback, onMouseUpCallback, onMouseDownCallback) {

    const onMouseUp = useCallback(e => {
        document.removeEventListener("mousemove", callback);
        document.removeEventListener("mouseup", onMouseUp);
        e.preventDefault();
        if (onMouseUpCallback) onMouseUpCallback(e);
    }, [callback, onMouseUpCallback]);

    const onMouseDown = useCallback((e) => {
        document.addEventListener("mousemove", callback);
        document.addEventListener("mouseup", onMouseUp);
        if (onMouseDownCallback) onMouseDownCallback(e);
    }, [callback, onMouseUp, onMouseDownCallback])

    useEffect(() => {
        const tmp = element.current;
        tmp.addEventListener("mousedown", onMouseDown);

        return () => {
            tmp.removeEventListener("mousedown", onMouseDown);
        }
    }, [element, onMouseDown]);

}
